<main id="main-content" class="h-screen flex flex-col pl-10 py-4 pr-4 transition-all duration-0">
    <div class="flex flex-row items-center justify-between p-2">
        <h1 class="oswald-font text-3xl">
            EMERGENCY OPERATIONS PLAN SUMMARY
        </h1>
        <button
            class="px-2.5 py-1.5 flex items-center justify-center gap-1 rounded bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:from-nside-orange-100 hover:to-nside-orange-200 text-white oswald-font disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:from-nside-orange-300 disabled:hover:to-nside-orange-400"
            [disabled]="downloading"
            (click)="$event.preventDefault(); downloadEop();"
        >
            <lucide-icon [name]="icons.Download" [size]="20"></lucide-icon>
            {{ downloading ? 'Preparing EOP...' : 'Download EOP' }}
        </button>
    </div>
    <!-- DASHBOARD -->
    <div class="p-2 space-y-2 flex flex-col flex-grow overflow-y-auto">
        <!-- dashboard top -->
        <div class="w-full flex flex-row items-center text-center space-x-2 px-6 text-sm">
            <div class="w-2/5"></div>
            <div class="w-1/5">Status</div>
            <div class="w-1/5">Last Updated</div>
            <div class="w-1/5">Updated By</div>
        </div>
        <!-- dashboard body -->
        <div class="w-full flex flex-col space-y-2 items-center overflow-y-auto h-full">
            <div *ngFor="let step of summary | keyvalue: preserveOrder" class="w-full flex flex-col items-center px-6 py-2 bg-white rounded-md shadow-md">
                <div class="w-full flex items-center oswald-font text-lg">
                    {{ step.key }}
                </div>
                <div class="w-full flex flex-col pt-1">
                    <div *ngFor="let item of step.value" class="w-full flex flex-row items-center">
                        <div class="w-2/5">
                            <p class="pl-10">{{ item.section }}</p>
                        </div>
                        <!-- STATUS ICON -->
                        <div class="w-1/5 text-center flex justify-center">
                            <div class="relative group">
                            <!-- Complete -->
                            <svg *ngIf="getStatusIcon(item.last_updated_at) === 'complete'" xmlns="http://www.w3.org/2000/svg"
                                width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-circle-check text-green-600">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                        
                            <!-- Need Attention -->
                            <svg *ngIf="getStatusIcon(item.last_updated_at) === 'attention'" xmlns="http://www.w3.org/2000/svg"
                                width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-triangle-alert text-amber-400">
                                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                <path d="M12 9v4" />
                                <path d="M12 17h.01" />
                            </svg>
                        
                            <!-- Incomplete -->
                            <svg *ngIf="getStatusIcon(item.last_updated_at) === 'incomplete'" xmlns="http://www.w3.org/2000/svg"
                                width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-circle-alert text-red-500">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" x2="12" y1="8" y2="12" />
                                <line x1="12" x2="12.01" y1="16" y2="16" />
                            </svg>
                        
                            <!-- Tooltip -->
                            <div class="absolute invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-300 bg-nside-gray-400 text-white text-sm rounded-md px-2 py-1 left-1/2 transform -translate-x-1/2 mt-1 z-10 whitespace-nowrap">
                                {{ getStatusIcon(item.last_updated_at) === 'complete' ? 'Complete' :
                                getStatusIcon(item.last_updated_at) === 'attention' ? 'Need Attention' : 'Incomplete' }}
                            </div>
                            </div>
                        </div>
      
                        <div class="w-1/5 oswald-font text-center">
                            {{ item.last_updated_at  | date: 'MM/dd/yyyy'}}
                        </div>
                        <div class="w-1/5 text-center">
                            {{ item.last_updated_user_name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <prv-next-buttons></prv-next-buttons>

</main>

<!-- Spinner -->
<div *ngIf="loading || downloading">
    <spinner></spinner>
</div>

<popup-message
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>